module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModelListPage', {
    attrs: {
      "lower-app-name": "emarket",
      "lower-model-name": "goods",
      "version": "2",
      "title": "商品列表"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5168236c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/GoodsList.vue
// module id = 375
// module chunks = 1